import type { PriceListBuilderValidated } from './schemas';
import type { PriceList, PriceListRule } from './types';

/**
 * Builds the create payload from validated builder state. Shared by the full builder form and the
 * onboarding one-click discount path so a list made either way is byte-for-byte identical.
 */
export function priceListBuilderToPriceList(state: PriceListBuilderValidated): PriceList {
  const rules: PriceListRule[] = [];
  if (state.automaticPricing) {
    let adjustPercent = 0;
    let adjustDir: PriceListRule['adjustment_direction'] = 'minus';
    if (state.automaticPricing.percentageVariation) {
      adjustPercent = state.automaticPricing.percentageVariation.amount / 100.0;
      adjustDir = state.automaticPricing.percentageVariation.direction;
    }

    rules.push({
      source_price_list_slug: state.automaticPricing.priceListSource,
      adjustment_percentage: adjustPercent,
      adjustment_direction: adjustDir,
      currency_exchange_rate: state.automaticPricing.exchangeRate,
    });
  }

  return {
    slug: state.handle,
    name: state.name,
    currency_code: state.currency,
    source: 'custom',
    rules,
  };
}
